import React from "react";
import image from "../../../assets/Group 48096931.png";
import arrow from "../../../assets/Monochrome.png";
import "./WhatIsMula.css";

const WhatIsMula = () => {
  return (
    <div className="token__section">
      <div className="token__section__text">
        <h1>
          What is <span>MULA Token</span>?
        </h1>
        <p>
          The Mula token is a virtual currency serving as a transferable and
          tradable asset or utility performer within the Mula ecosystem. Mula
          token resides on the Binance smart-chain and also allows the holder to
          invest in Defi protocols such as Cassava.
        </p>
        <div className="token__section__text__button">
          <button className="token__section__first__button">
            <div className="token__section__first__button__image">
              <img src={arrow} alt="" />
            </div>
            START USING MULA TOKEN
          </button>
          <button className="token__section__second__button">
            <div className="token__section__second__button__image">
              <img src={arrow} alt="" />
            </div>
            WHITE PAPER
          </button>
        </div>
      </div>
      <div className="token__section__image">
        <img src={image} alt="" />
      </div>
    </div>
  );
};

export default WhatIsMula;
